import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Osoba } from './osoba';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-osoba-modal-update',
  templateUrl: './osoba-modal-update.component.html',
})
export class OsobaModalUpdateComponent
 extends BaseModalUpdateComponent<Osoba>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Osoba>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);    
  }

  ngOnInit() {
  }

}
